import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import PdfStore from 'stores/PdfStore'
import WorkdocStore from 'stores/WorkdocStore'
import { FormControl } from 'react-bootstrap'
import './Print.css'
import fuelgaugeSrc from 'asset/img/fuelgauge3-150.png';
import carBody from './car_body.png'
import FontAwesome from 'react-fontawesome'
import TextFieldModal from 'component/element/TextFieldModal'
var NotificationSystem = require('react-notification-system')
class PrintZongParkingCarDoc extends Component {

    constructor(...args) {
        super(...args)
        
        this.state = {
            loading:false,
            report_title:'กำลังดึงข้อมูล..',
            data:{
                car:{car_registration_no:'',brand:'',model:''},
                driver:{},
                insurer:{insurer_id:'',insurer_name:''},
                owner:{},
                pdf_config:{},
                receiving:{entrance_date:'',entrance_name:'',title:'',entrance_name_as:'',tel:''},
                related_detail:{
                    asset_check:[{exist:undefined,quantity:''},{exist:undefined,quantity:''},{exist:undefined,quantity:''},{exist:undefined,quantity:''},{exist:undefined,quantity:''},{exist:undefined,quantity:''},{exist:undefined,quantity:''},{exist:undefined,quantity:''},{exist:undefined,quantity:''},{exist:undefined,quantity:''},{exist:undefined,quantity:''},{exist:undefined,quantity:''},{exist:undefined,quantity:''}],
                    damage_check:[{normal:undefined},{normal:undefined},{normal:undefined},{normal:undefined},{normal:undefined},{normal:undefined},{normal:undefined}],
                    remarklist:['',''],
                    fuel_gauge:{fuel:{x:'',y:''}}
                }
            }    
        }
        
        var cssPagedMedia = (function() {
            var style = document.createElement('style');
            document.head.appendChild(style);
            return function (rule) {
                style.innerHTML = rule;
            };
        }());
  
        cssPagedMedia.size = function(size) {
            cssPagedMedia('@page {size: ' + size + '}');
        };
        cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        this.loadData()
    }

    loadData() {
        PdfStore.loadParkingcarDoc(this.props.workNo,(result)=>{
            let data = result.data
            data.related_detail = Object.assign(this.state.data.related_detail,data.related_detail)
            data = Object.assign(this.state.data,data)
            this.setState({loading:false,data:data})
            this.setFuelgauge(data.related_detail.fuel_gauge)
        },()=>{
            this.setState({loading:false})
        })
    }

    saveParkingcarDoc(data) {
        let {workNo} = this.props
        let that = this

        WorkdocStore.saveWorkdocRelated(workNo,'parking_doc',data.related_detail,function(result){
        that._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'ทำการบันทึกรายละเอียดเอกสารประกอบเลขงานซ่อม ' + workNo + ' เรียบร้อย',
            level: 'info',
            position: 'tc',        
        });
        },function(){
        that._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'มีความผิดพลาดเกิดขึ้นในการบันทึกเอกสารประกอบเลขงานซ่อม ' + workNo + ' ',
            level: 'error',
            position: 'tc'
        });
        })
    }

    setFuelgauge(fuel_gauge) {
        const contextFuelgauge = this.canvasFuelgauge.getContext('2d')
        const imageFuelgauge = new Image()
        imageFuelgauge.src = fuelgaugeSrc
        imageFuelgauge.onload = () => {
            contextFuelgauge.drawImage(imageFuelgauge, 0, 0, this.canvasFuelgauge.width, this.canvasFuelgauge.height)
            this.setDrawLine(fuel_gauge)
        }
    }
    
    setDrawLine(fuel_gauge) {
        const context = this.canvasFuelgauge.getContext('2d')
        const imageFuelgauge = new Image()
        imageFuelgauge.src = fuelgaugeSrc
        context.drawImage(imageFuelgauge, 0, 0, 100, 50);
        var x = fuel_gauge.fuel['x']
        var y = fuel_gauge.fuel['y']
        if (x!==""&&y!=="") {
            context.beginPath();
            context.moveTo(x, y);
            context.lineTo(50, 50);
            context.lineWidth = 5;
    
            context.strokeStyle = '#ff0000';
            context.stroke();
        }     
    }
    
    onDrawLine(e) {
        let {data} = this.state
        let {fuel_gauge} = data.related_detail
        var r = this.canvasFuelgauge.getBoundingClientRect();
        var x = e.clientX - r.left;
        var y = e.clientY - r.top;
        fuel_gauge.fuel['x'] = x
        fuel_gauge.fuel['y'] = y
        this.setFuelgauge(fuel_gauge);
        this.setState({data:data})
        this.saveParkingcarDoc(data)
    }

    onAssetClick(index) {
        let {data} = this.state
        let {asset_check} = data.related_detail
        if (asset_check[index].exist===undefined) {
            asset_check[index].exist = true
        } else {
            if (asset_check[index].exist)
                asset_check[index].exist = false
            else
                asset_check[index].exist = true
        }
        this.setState({data:data})
        this.saveParkingcarDoc(data)
    }

    onAssetQuantityChange(index,e) {
        let {data} = this.state
        let {asset_check} = data.related_detail
    
        asset_check[index].quantity = e.target.value
        this.setState({data:data})
        this.saveParkingcarDoc(data)
    }

    onDamageClick(index) {
        let {data} = this.state
        let {damage_check} = data.related_detail
        if (damage_check[index].normal===undefined) {
            damage_check[index] = {}
            damage_check[index] = Object.assign(damage_check[index], {normal:true})
        } else {
            if (damage_check[index].normal)
                damage_check[index].normal = false
            else
                damage_check[index].normal = true
        }
        this.setState({data:data})
        this.saveParkingcarDoc(data)
    }

    onRemarkSave(fieldInfo) {
        let {data} = this.state
        data.related_detail.remarklist[fieldInfo.index] = fieldInfo.value
        this.setState({data:data})
        this.saveParkingcarDoc(data)
    }
    
    onRemarkClick(index) {
        let {data} = this.state
        let {remarklist} = data.related_detail
        let fieldInfo = {title:'ใส่ข้อมูลหมายเหตุ',showClear:false,index:index,value:remarklist[index]}
        this.refs.textFieldModal.loadInfo(fieldInfo)
    }

    onMileageClick() {

    }
    
    renderFuelgauge() {
        return(
            <div>                
                <canvas
                    onClick={this.onDrawLine.bind(this)}
                    ref={canvasFuelgauge => this.canvasFuelgauge = canvasFuelgauge}
                    width="100" height="50"
                >
                    <p>Error</p>
                </canvas>
            </div>
        )
    }

    renderHeaderLeft() {
        let {data} = this.state
        return(
            <div>
                <div>
                    {this.renderLogoUrl('../img/logo-demo2-128x128.png')}
                </div>
                <div style={{marginTop:'10px'}}>
                    <p>{data.company_name}</p>
                    <p>{data.company_addr}</p>
                    <p>Tel : {data.company_tel!==''?data.company_tel:''}, Fax : {data.company_fax!==''?data.company_fax:''}</p>
                    <p>Website : {data.company_website!==''&&data.company_website!==undefined?data.company_website:''}</p>
                    <p>Email : {data.company_email!==''&&data.company_email!==undefined?data.company_email:''}</p>
                    <p>Facebook : {data.company_facebook!==''&&data.company_facebook!==undefined?data.company_facebook:''}</p>
                </div>
            </div>
        )
    }

    renderHeaderRight() {
        let {data} = this.state
        return(
            <div>
                <table className='table table-print-zong-parking-car-doc'>
                    <tbody>
                        <tr>
                            <td className='text-center header-title'>{this.props.title}</td>
                        </tr>
                        <tr>
                            <td>ชื่อลูกค้า Name {data.owner.name!==''&&data.owner.name!==null&&data.owner.name!==undefined?data.owner.name:'...............................................................'}</td>
                        </tr>
                        <tr>
                            <td>โทร Tel {data.owner.tel!==''&&data.owner.tel!==null&&data.owner.tel!==undefined?data.owner.tel:'............................................................................'}</td>
                        </tr>
                        <tr>
                            <td>เลขทะเบียน Reg. No. {data.car.car_registration_no!==''&&data.car.car_registration_no!==null&&data.car.car_registration_no!==undefined?data.car.car_registration_no:'.....................................................'}</td>
                        </tr>
                        <tr>
                            <td>ยี่ห้อ Brand {data.car.brand!==''&&data.car.brand!==null&&data.car.brand!==undefined?data.car.brand:'......................................................................'}</td>
                        </tr>
                        <tr>
                            <td>รุ่น Model {data.car.model!==''&&data.car.model!==null&&data.car.model!==undefined?data.car.model:'.......................................................................'}</td>
                        </tr>
                        <tr>
                            <td>สี Color {data.car.car_color!==''&&data.car.car_color!==null&&data.car.car_color!==undefined?data.car.car_color:'...........................................................................'}</td>
                        </tr>
                        <tr>
                            <td>บริษัทประกันภัย Insurance Company</td>
                        </tr>
                        <tr>
                            <td>{data.insurer_name!==''&&data.insurer_name!==null&&data.insurer_name!==undefined?data.insurer_name:'..........................................................................................'}</td>
                        </tr>
                        <tr>
                            <td>วันที่รับรถเข้าซ่อม Date-in {data.receiving.entrance_date!==''&&data.receiving.entrance_date!==null&&data.receiving.entrance_date!==undefined?data.receiving.entrance_date:'..............................................'}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }            

    renderCheckCar() {
        let {data} = this.state
        return(
            <div style={{width:'100%',display:'flex',border:'1px solid #111',padding:'5px'}}>
                <div style={{width:'70%'}}>
                    ตรวจสภาพทั่วไปรอบนอกตัวถัง
                    <div>
                        <img alt='' src={carBody} height='180px' width='90%' />
                    </div>
                </div>
                <div style={{width:'30%'}}>
                    ระดับน้ำมันเชื้อเพลิง Fuel Level
                    <div className='text-center' style={{marginTop:'50px',marginBottom:'50px'}}>
                        {this.renderFuelgauge()}
                    </div>
                    เลขไมล์ Mileage <span onClick={this.onMileageClick.bind(this)}>{data.car.mileage===''||data.car.mileage===null||data.car.mileage===undefined?'...............................':data.car.mileage}</span>
                </div>
            </div>
        )
    }

    renderDetail() {
        let {asset_check,damage_check,remarklist} = this.state.data.related_detail
        let check = (<span>(<FontAwesome style={{fontSize:'12px'}} name='check'/>)</span>)
        let _check = (<span>(&nbsp;&nbsp;&nbsp;)</span>)
        return(
            <div style={{width:'100%',display:'flex'}}>
                <div style={{width:'60%'}}>
                    <div>
                        <table className='table table-print-zong-parking-car-doc' style={{marginBottom:'0',borderBottom:'none'}}>
                            <tbody>
                                <tr>
                                    <td style={{width:'55%'}} className='bd-r title'>สภาพรถและอุปกรณ์ TOOLKITS</td>
                                    <td style={{width:'45%'}} className='title'>ระบบไฟฟ้า ELECTRIC SYSTEM</td>
                                </tr>
                                <tr>
                                    <td className='bd-r' onClick={this.onAssetClick.bind(this,0)}>{asset_check[0].exist!==undefined&&asset_check[0].exist?check:_check} ที่จุดบุหรี่ Front Lighter</td>
                                    <td onClick={this.onDamageClick.bind(this,0)}>{damage_check[0].normal!==undefined&&damage_check[0].normal?check:_check} กระจกมองข้างไฟฟ้า</td>
                                </tr>
                                <tr>
                                    <td className='bd-r'><span onClick={this.onAssetClick.bind(this,1)}>{asset_check[1].exist!==undefined&&asset_check[1].exist?check:_check}</span> ผ้ายางปูพื้น <span style={{width:'20px'}} className='text-center'><FormControl onChange={this.onAssetQuantityChange.bind(this,1)} value={asset_check[1].quantity}/></span> ชิ้น Foolr Mats</td>
                                    <td onClick={this.onDamageClick.bind(this,1)}>{damage_check[1].normal!==undefined&&damage_check[1].normal?check:_check} กระจกประตูไฟฟ้า</td>
                                </tr>
                                <tr>
                                    <td className='bd-r' onClick={this.onAssetClick.bind(this,2)}>{asset_check[2].exist!==undefined&&asset_check[2].exist?check:_check} เครื่องเสียง/วิทยุ/ลำโพง Radio System</td>
                                    <td onClick={this.onDamageClick.bind(this,2)}>{damage_check[2].normal!==undefined&&damage_check[2].normal?check:_check} เซนทรัลล็อกประตู</td>
                                </tr>
                                <tr>
                                    <td className='bd-r' onClick={this.onAssetClick.bind(this,3)}>{asset_check[3].exist!==undefined&&asset_check[3].exist?check:_check} ฟิล์มติดกระจก Film</td>
                                    <td onClick={this.onDamageClick.bind(this,3)}>{damage_check[3].normal!==undefined&&damage_check[3].normal?check:_check} ระบบปัดน้ำฝน</td>
                                </tr>
                                <tr>
                                    <td className='bd-r' onClick={this.onAssetClick.bind(this,4)}>{asset_check[4].exist!==undefined&&asset_check[4].exist?check:_check} เสาอากาศ Radio Antena</td>
                                    <td onClick={this.onDamageClick.bind(this,4)}>{damage_check[4].normal!==undefined&&damage_check[4].normal?check:_check} ระบบเซ็นเซอร์</td>
                                </tr>
                                <tr>
                                    <td className='bd-r' onClick={this.onAssetClick.bind(this,5)}>{asset_check[5].exist!==undefined&&asset_check[5].exist?check:_check} ถุงเครื่องมือ Tool Set</td>
                                    <td onClick={this.onDamageClick.bind(this,5)}>{damage_check[5].normal!==undefined&&damage_check[5].normal?check:_check} ระบบแอร์</td>
                                </tr>
                                <tr>
                                    <td className='bd-r' onClick={this.onAssetClick.bind(this,6)}>{asset_check[6].exist!==undefined&&asset_check[6].exist?check:_check} แม่แรง Jack</td>
                                    <td onClick={this.onDamageClick.bind(this,6)}>{damage_check[6].normal!==undefined&&damage_check[6].normal?check:_check} ระบบไฟอื่นๆ</td>
                                </tr>
                                <tr>
                                    <td className='bd-r' onClick={this.onAssetClick.bind(this,7)}>{asset_check[7].exist!==undefined&&asset_check[7].exist?check:_check} ยางอะไหล่ Spare Tyre</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className='bd-r'><span onClick={this.onAssetClick.bind(this,8)}>{asset_check[8].exist!==undefined&&asset_check[8].exist?check:_check}</span> ฝาครอบล้อ <span style={{width:'20px'}} className='text-center'><FormControl onChange={this.onAssetQuantityChange.bind(this,8)} value={asset_check[8].quantity}/></span> อัน Wheel Caps</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className='bd-r' onClick={this.onAssetClick.bind(this,9)}>{asset_check[9].exist!==undefined&&asset_check[9].exist?check:_check} ยางกันโคลนหน้า Front Mud Guards</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className='bd-r' onClick={this.onAssetClick.bind(this,10)}>{asset_check[10].exist!==undefined&&asset_check[10].exist?check:_check} ยางกันโคลนหลัง Back Mud Guards</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className='bd-r'><span onClick={this.onAssetClick.bind(this,11)}>{asset_check[11].exist!==undefined&&asset_check[11].exist?check:_check}</span> กุญแจรถ Car Keys <span style={{width:'20px'}} className='text-center'><FormControl onChange={this.onAssetQuantityChange.bind(this,11)} value={asset_check[11].quantity}/></span></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className='bd-r'><span onClick={this.onAssetClick.bind(this,12)}>{asset_check[12].exist!==undefined&&asset_check[12].exist?check:_check}</span> อื่นๆ <span style={{width:'20px'}} className='text-center'><FormControl onChange={this.onAssetQuantityChange.bind(this,12)} value={asset_check[12].quantity}/></span></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <table className='table table-print-zong-parking-car-doc' style={{marginBottom:'0',borderBottom:'none'}}>
                            <tbody>
                                <tr>
                                    <td colSpan={2} className='title'>ค่าใช้จ่าย Expense</td>
                                </tr>
                                <tr>
                                    <td style={{width:'100px'}}>ค่าเงื่อนไข Excess</td>
                                    <td className='text-center'>...............................................................................................</td>
                                </tr>
                                <tr>
                                    <td style={{width:'100px'}}>ค่าส่วนต่าง</td>
                                    <td className='text-center'>...............................................................................................</td>
                                </tr>
                                <tr>
                                    <td style={{width:'100px'}}>ค่าเพิ่มเติม</td>
                                    <td className='text-center'>...............................................................................................</td>
                                </tr>
                                <tr>
                                    <td style={{width:'100px'}}>ค่าใช้จ่ายอื่นๆ</td>
                                    <td className='text-center'>...............................................................................................</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <table className='table table-print-zong-parking-car-doc' style={{marginBottom:'0'}}>
                            <tbody>
                                <tr>
                                    <td colSpan={2} className='title'>หมายเหตุ Remark</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} onClick={this.onRemarkClick.bind(this,0)}>{remarklist[0]===''?'.........................................................................................................................................':remarklist[0]}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>            
                </div>
                <div style={{width:'40%'}}>
                    {this.renderDescription()}
                </div>
            </div>
        )
    }

    renderDescription() {
        return(
            <div style={{borderTop:'1px solid #111',borderBottom:'1px solid #111',borderRight:'1px solid #111',padding:'5px'}}>
                <div>
                    เรียนผู้มีอุปการะคุณ <br />
                    เลขไมล์หลังเข้ารับบริการอาจเพิ่มขึ้นเนื่องจากขั้นตอนการให้บริการ
                    หรือขั้นตอนวิ่งทดสอบรถยนต์หลังซ่อมเสร็จ
                    รายการซ่อมจุดที่เสียหาย สีอาจมีสภาพต่างไปจากเดิมเนื่องจาก
                    สภาพสีรถเดิมและ/หรือ ตัววัสดุที่รับบริการ
                    รายการซ่อมจุดที่เสียหาย อาจพ่นสีบริเวณใกล้เคียง เพื่อปรับสีให้มี
                    ลักษณะใกล้เคียงมากที่สุด
                    ขอความกรุณาลูกค้าที่นำรถมาจอดซ่อมตัวถังและสีกรุณาเก็บ
                    ทรัพย์สินมีค่ามากกว่า 50 บาทเช่นเศษเหรียญ เงินแบงก์ กล้องดิจิตอล
                    โทรศัพท์มือถือ พระเครื่อง ฯลฯ ภายในรถออกให้หมดก่อน
                    นำรถเข้ามาซ่อมตัวถังและสี ทางบริษัทฯ ได้แจ้งลูกค้าแล้ว
                    หากเกิดการสูญเสียหรือเสียหาย ทางบริษัทจะไม่รับผิดชอบใดๆทั้งสิ้น 
                    <br />
                    <br />
                    I have already brought my valuables out of my car and also
                    approved items as show in this document. <br />
                    The company will not be held resposible for any damage or
                    loss of personal belongings left in the car whife in our custody
                    Futhemore  we cannot be held trable for damages
                    causes any third persons.
                </div>
                <div className='signature text-center' style={{marginTop:'25px'}}>
                    .........................................................
                </div>
                <div className='text-center'>
                    ลายเซ็นต์ลูกค้า / Customer Signature
                </div>
            </div>
        )
    }

    renderComponentPage() {
        return(  
            <div className='font-print print-zong-parking-car-doc'>
                <div style={{width:'100%',display:'flex'}}>
                    <div style={{width:'60%'}}>
                        {this.renderHeaderLeft()}
                    </div>
                    <div style={{width:'40%'}}>
                        {this.renderHeaderRight()}
                    </div>
                </div>
                {this.renderCheckCar()}
                <br />
                {this.renderDetail()}
            </div>
        )    
    }

    renderLogoUrl(logoUrl){
        if(logoUrl===undefined){
          return ('')
        }
        let imgUrl = ''
        if (process.env.NODE_ENV === "development") {
          imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
        }else{
          imgUrl = '../'+logoUrl
        }
        return (<img alt='' src={imgUrl} style={{maxWidth:'100px'}}/>)
      }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading} = this.state
        return(
            <div>
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {this.renderComponentPage()}    
                </PrintPreview>
                <TextFieldModal 
                    ref='textFieldModal'
                    confirmTitle='บันทึก'
                    onConfirm={this.onRemarkSave.bind(this)}
                />
                <NotificationSystem ref="notificationSystem" />
            </div>    
        )      
    }
}

PrintZongParkingCarDoc.defaultProps = {
    title: 'ใบรับรถซ่อมตัวถังและสี',
    mode: '',
    workNo: ''
}
export default PrintZongParkingCarDoc;


// WEBPACK FOOTER //
// ./src/view/print/zong/PrintZongParkingCarDoc.js